import { render, staticRenderFns } from "./SSelectCompanycomponent.vue?vue&type=template&id=7fafb810"
import script from "./SSelectCompanycomponent.vue?vue&type=script&lang=js"
export * from "./SSelectCompanycomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports